import { render, staticRenderFns } from "./certified-badge.vue?vue&type=template&id=fd89aef6&"
import script from "./certified-badge.vue?vue&type=script&lang=ts&"
export * from "./certified-badge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports